import { useProviderSearchContext } from "context/ProviderSearchContext";
import { activateEUSCMaintenanceBanner } from "core/model/utils/featureFlags";
import {
  AppBarProviderSearch,
  LeftPart,
  LogoWrapper,
} from "ds_legacy/components/AppBar";
import { sizing } from "ds_legacy/materials/metrics";
import Image from "dsl/atoms/Image";
import { ErrorBanner } from "dsl/atoms/Navbar/ErrorBanner";
import { useMedia } from "dsl/atoms/ResponsiveMedia";
import { useProvidersearchNavigationUrls } from "dsl/hooks/useNavigationHandlers";
import { useTranslations } from "translations";
import SkipLink from "../A11ySkipLink";
import { NavBarActions } from "./NavBarActions";

const ProviderSearchLogo = () => {
  const { goToListing } = useProvidersearchNavigationUrls();
  const translations = useTranslations();
  const { config } = useProviderSearchContext();
  const { isMobile } = useMedia();
  return (
    <LogoWrapper to={goToListing()}>
      <Image
        alt={config.logos.default.altText(translations)}
        path={isMobile ? config.logos.mobile : config.logos.default.path}
        style={{ height: isMobile ? sizing(6) : sizing(7) }}
      />
    </LogoWrapper>
  );
};

export function Header({
  isFiltersDrawerOpen,
}: {
  isFiltersDrawerOpen: boolean;
}) {
  const translations = useTranslations();

  return (
    <>
      <AppBarProviderSearch isFiltersDrawerOpen={isFiltersDrawerOpen}>
        <LeftPart>
          <SkipLink />
          <ProviderSearchLogo />
        </LeftPart>
        <nav
          aria-label={
            translations.providersearch.header.mainNavigationAriaLabel
          }
          style={{
            alignItems: "center",
            display: "flex",
            flex: 1,
            justifyContent: "flex-end",
          }}
        >
          <NavBarActions />
        </nav>
      </AppBarProviderSearch>
      {activateEUSCMaintenanceBanner && <ErrorBanner />}
    </>
  );
}
